import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dasboard',
  templateUrl: './dasboard.component.html',
  styleUrls: ['./dasboard.component.css'],
})
export class DasboardComponent implements OnInit {
  constructor(private s: GeneralService, private r: Router) {}
  units = 0;
  status = false;
  displayedColumns: string[] = [
    'email',
    'netPrice',
    'grossPrice',
    // 'percentage',
    'status',
    'updated_at',
    'policy_detail_id',
  ];
  dataSource: any;
  commission = 0.0;
  gross = 0.0;
  policyCount = 0;
  claimAmount = 0;
  claimCount = 0
  user: { [key: string]: string } = {};
  openCoverExpiry = false;
  policyButton = true;
  claimsDetails: any;

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user')!);
    if (localStorage.getItem('qoute')) {
      this.r.navigateByUrl('/main/create-policy');
    }
    if (this.user['status'] == 'approved') {
      this.status = true;
    }

    console.log(this.user);

    if (!this.user['unitFn'] && this.user['role'] == 'broker') {
      this.openCoverExpiry = true;
    }

    if (!this.user['unitFn'] && this.user['role'] == 'staff') {
      this.openCoverExpiry = true;
      this.policyButton = false;
    }

    if (this.user['role'] != 'broker' && this.user['role'] != 'staff') {
      this.openCoverExpiry = false;
    }

    this.s.getAllTrxns().subscribe((r: any) => {
      console.log(r);
      this.s.loader = false;
      this.policyCount = r.data.length;

      let arr = [];
      let arr1 = [];
      r.data = r.data.reverse();
      for (let index = 0; index < r.data.length; index++) {
        if (r.data[index].status == 'paid' && !(arr1.length == 5))
          arr1.push(r.data[index]);
      }
      for (let index = 0; index < r.data.length; index++) {
        if (r.data[index].status == 'paid') {
          this.gross = this.gross + parseFloat(r.data[index]['grossPrice']);
          r.data[index]['commission'] =
            parseFloat(r.data[index]['grossPrice']) -
            parseFloat(r.data[index]['netPrice']);
          arr.push(r.data[index]);
        }
      }
      this.dataSource = new MatTableDataSource(arr1);
    });
    this.s.getCommission().subscribe((r: any) => {
      this.s.loader = false;
      this.commission = r.data.balance;
    });

    if (this.user['units']) {
      this.units = parseInt(this.user['units'], 10);
    }

    if (!localStorage.getItem('reloaded')) {
      localStorage.setItem('reloaded', 'true');
      location.reload();
    }

    this.getClaims(this.user['email']);
  }

  getClaims(email: any) {
    this.s.getAClaim({ email }).subscribe((res: any) => {
      this.claimsDetails = res.data;
      console.log(this.claimsDetails);
      this.claimCount = this.claimsDetails.length

      for (let i = 0; i < this.claimsDetails.length; i++) {
        if (this.claimsDetails[i]['gross_premium']) {
          this.claimAmount += parseFloat(
            this.claimsDetails[i]['gross_premium']
          );
        }
      }
    });
  }

}
